import underscoreSource from 'underscore';

if (!window._ && !globalThis._) {
  // Execute the legacy bundle outside the webpack module wrapper.
  // The file expects top-level this to resolve to the global object.

  new Function(underscoreSource)();
}

const resolvedUnderscore = window._ || globalThis._;

if (!resolvedUnderscore || typeof resolvedUnderscore.each !== 'function') {
  throw new Error('Underscore global was not initialized');
}

window._ = resolvedUnderscore;

export default resolvedUnderscore;
